<script>
import Layout from '@layouts/main.vue'
import popup from '@utils/popup.js'
import excessPopup from '@utils/popup-search-result-excess.js'
import popupGuest from '@utils/popup-guest.js'
import {
  setSessionItem,
  getFaciliteisSearchParam,
  clearSessionSearch,
} from '@utils/session.js'
import {
  genre,
  DISPLAYMODE,
  isConditionEmpty,
  toSearchResultWithQuery,
} from '@state/modules/facility-search.js'
import { API_SHOP_LIST_FC } from '@utils/api.js'
import withCouponIcon from '@img/icon_with_coupon.png'
import * as SwiperMap from '@/node_modules/swiper/swiper-bundle.min.js'
import { watchPosition } from '@utils/geoLocation.js'
import { getClientType } from '@utils/client'
import noImg from '@img/map/noimage.png'
import redMarker from '@img/map/yahooMarkerIcon.png'
import blueMarker from '@img/map/yahooMarkerIcon_青.png'

export default {
  name: 'Map',
  metaInfo: {
    title: '地図表示 | JAFナビ',
    meta: [{ name: 'description', content: '地図表示' }],
  },
  components: { Layout },
  data() {
    return {
      preMarkerId: 0,
      showMask: false,
      marker: null,
      hasResult: false,
      noImg,
      center: {},
      markers: [],
      places: [],
      map: null,
      popup: null,
      limit: 150,
      shopList: [],
      shopMode: '0',
      isBack: false,
      mapSwiper: null,
      searchButtonFlag: false,
      searchingFlag: false,
      research_flag: false,
      count: 0,
      SORT_NAME: '1',
      SORT_DIST: '2',
      showSlide: !(window.innerWidth >= 768),
      now_pos_flag: false,
      withCouponIcon,
      // ヒットなし
      noHit: false,
      DISPLAYMODE,
      selectedIndex: 0,
      isGASend: false,
      isReserchGASend: false,
      isAlertGASend: false,
    }
  },
  computed: {
    defaultImage() {
      return "this.src ='" + noImg + "'"
    },
    slideAreaCss() {
      return this.shopList && this.shopList.length > 0 ? '' : 'no_result'
    },
    isMobile() {
      return window.innerWidth < 768
    },
    isLinksMode() {
      if (this.$store.state.auth.userType == '80' && this.$store.state.auth.loggedIn) {
        return true
      }

      return false
    },
  },
  watch: {
    immediate: true,
    deep: true,
    $route(to, from) {
      this.isBack = false

      if (
        to.name === 'map' &&
        from.name === 'facility-search' &&
        from.meta.isBack
      ) {
        this.isBack = true
      }

      if (to.name === 'map' && from.name === 'facility-detail') {
        this.isBack = true
      }
    },
  },
  created() {},
  mounted() {
    if (isConditionEmpty()) {
      window.location.replace('https://jafnavi.jp')
      return
    }

    // setSessionItem('PRE_SCREEN_ID', 'SU-03')

    if (this.isBack) {
      return
    }

    this.center = {
      lat:
        sessionStorage.getItem('LAT') && sessionStorage.getItem('LAT') != ''
          ? JSON.parse(sessionStorage.getItem('LAT')) || 35.681167
          : 35.681167,
      lng:
        sessionStorage.getItem('LAT') && sessionStorage.getItem('LAT') != ''
          ? JSON.parse(sessionStorage.getItem('LON')) || 139.767052
          : 139.767052,
    }
    if (this.$store.state.facilitySearch.isNowAround) {
      this.now_pos_flag = true
    }
    if(!this.isGASend) {
      this.isGASend = true
      window.dataLayer.push({
        event: 'Webview',
        ap_screen_name: 'JAFナビ_地図から検索_地図表示',
      })
    }
    this.$store.dispatch('layout/startLoading')
    this.$store.dispatch('layout/disableFocusHide')
    this.initSwiper()
    this.getShopList()
    this.windowHeightSet()
  },
  activated() {
    // setSessionItem('PRE_SCREEN_ID', 'SU-03')

    if (this.isBack) {
      return
    }

    this.center = {
      lat:
        sessionStorage.getItem('LAT') && sessionStorage.getItem('LAT') != ''
          ? JSON.parse(sessionStorage.getItem('LAT')) || 35.681167
          : 35.681167,
      lng:
        sessionStorage.getItem('LAT') && sessionStorage.getItem('LAT') != ''
          ? JSON.parse(sessionStorage.getItem('LON')) || 139.767052
          : 139.767052,
    }
    if (this.$store.state.facilitySearch.isNowAround) {
      this.now_pos_flag = true
    }
    if(!this.isGASend) {
      this.isGASend = true
      window.dataLayer.push({
        event: 'Webview',
        ap_screen_name: 'JAFナビ_地図から検索_地図表示',
      })
    }
    this.$store.dispatch('layout/startLoading')
    this.$store.dispatch('layout/disableFocusHide')
    this.initSwiper()
    this.getShopList()
    this.windowHeightSet()
  },
  deactivated() {
    this.saveSession()
    this.isGASend = false
  },
  beforeDestroy() {
    this.saveSession()
    this.isGASend = false
  },
  methods: {
    showInformation(){
      this.$popup({
        text: "「おおよその位置情報」に設定していると、現在地がずれる場合があります。\n「正確な位置情報」に設定することでより正確な検索が可能となります。",
      })
    },
    closeMask() {
      this.showMask = !this.showMask
      this.hasResult = true
    },
    initMap() {
      mapboxgl.accessToken = this.$store.state.env.mapboxAccessToken
      // mapboxgl.accessToken =
      //   'pk.eyJ1IjoiZnNpZGV2ZWxvcCIsImEiOiJja2M5d3F4eGYxcG55MnNvMDI0MWoxYzZxIn0.BDLPdKoOW4MscSgYu5qGsQ'

      var parent = this
      var markerClicked = function () {
        parent.clickPoint(this.markll)
      }

      var zoom = 15
      var dist = sessionStorage.getItem('DIST')
      if (!sessionStorage.getItem('ZOOM')) {
        if (dist === '1') {
          zoom = 16
        } else if (dist === '5') {
          zoom = 15
        } else if (dist === '10') {
          zoom = 13
        } else if (dist === '20') {
          zoom = 11
        } else if (dist === '50') {
          zoom = 9
        } else {
          zoom = 15
        }
      } else {
        zoom = sessionStorage.getItem('ZOOM')
      }

      if (this.map) {
        this.map.remove()
      }

      if (this.popup) {
        this.popup.remove()
      }

      if (this.marker) {
        this.marker.remove()
      }

      if (Object.keys(this.shopList).length === 0) {
        this.map = new mapboxgl.Map({
          container: 'map_container',
          style: this.$store.state.env.mapboxStyle,
          // style: 'mapbox://styles/fsidevelop/ckca4luu33noe1immd1hvkdna',
          center: [Number(this.center.lng), Number(this.center.lat)],
          zoom: zoom,
        })
      } else if (this.count === 0) {
        this.map = new mapboxgl.Map({
          container: 'map_container',
          style: this.$store.state.env.mapboxStyle,
          // style: 'mapbox://styles/fsidevelop/ckca4luu33noe1immd1hvkdna',
          center: [
            Number(sessionStorage.getItem('LON')),
            Number(sessionStorage.getItem('LAT')),
          ],
          zoom: zoom,
        })
      } else {
        const initIndex =
          sessionStorage.getItem('index') &&
          sessionStorage.getItem('index') != 'undefined'
            ? sessionStorage.getItem('index')
            : 0

        this.preMarkerId = initIndex

        for (var i = 0; i < Object.keys(this.shopList).length; i++) {
          if (i === 0) {
            if (this.research_flag) {
              this.map = new mapboxgl.Map({
                container: 'map_container',
                style: this.$store.state.env.mapboxStyle,
                // style: 'mapbox://styles/fsidevelop/ckca4luu33noe1immd1hvkdna',
                // center: [
                //   Number(sessionStorage.getItem('LON')),
                //   Number(sessionStorage.getItem('LAT')),
                // ],
                center: [
                  Number(this.shopList[initIndex].LON),
                  Number(this.shopList[initIndex].LAT),
                ],
                zoom: zoom,
              })
            } else {
              this.map = new mapboxgl.Map({
                container: 'map_container',
                style: this.$store.state.env.mapboxStyle,
                // style: 'mapbox://styles/fsidevelop/ckca4luu33noe1immd1hvkdna',
                center: [
                  Number(this.shopList[initIndex].LON),
                  Number(this.shopList[initIndex].LAT),
                ],
                zoom: zoom,
              })
            }
          }
          const latlng = new mapboxgl.LngLat(
            Number(this.shopList[i].LON),
            Number(this.shopList[i].LAT)
          )

          var html = this.popupHTML(i)

          var popup = new mapboxgl.Popup({
            closeOnMove: false,
            offset: 15,
            closeButton: false,
          })
            .setLngLat(latlng)
            .setHTML(html)

          var el = document.createElement('div')
          if (i == initIndex) {
            el.className = 'marker2'
          } else {
            el.className = 'marker'
          }
          el.id = 'markerid' + i

          var marker = new mapboxgl.Marker(el)
            .setLngLat(latlng)
            .setPopup(popup)
            .addTo(this.map)

          const shopIndex = i

          popup._content.addEventListener('click', () => {
            if (!this.$store.state.auth.loggedIn && this.shopList[shopIndex].MENBER_ONLY_FLAG === '1') {
              this.$popup({
                text: '施設の詳細を表示するにはログインを行ってください。',
              })
            } else {
              this.$store.dispatch('layout/enableMapAlive')
              setSessionItem('PRE_SCREEN_ID', 'SU-03')
              this.$router.push({
                name: 'facility-detail',
                params: {
                  id:
                    this.shopList[shopIndex].FACILITIES_ID ||
                    this.shopList[shopIndex].SHISETU_ID,
                },
              })
            }
          })

          var markerPosition = marker.getLngLat()
          marker.getElement().addEventListener('click', {
            markll: markerPosition,
            handleEvent: markerClicked,
          })
        }

        // 吹き出し
        if (this.count > 0) {
          var html2 = this.popupHTML(initIndex)

          this.popup = new mapboxgl.Popup({
            closeOnMove: false,
            offset: 15,
            closeButton: false,
          })
            .setLngLat([
              Number(this.shopList[initIndex].LON),
              Number(this.shopList[initIndex].LAT),
            ])
            .setHTML(html2)
            .addTo(this.map)

          this.popup.getElement().addEventListener('click', () => {
            if (!this.$store.state.auth.loggedIn && this.shopList[initIndex].MENBER_ONLY_FLAG === '1') {
              this.$popup({
                text: '施設の詳細を表示するにはログインを行ってください。',
              })
            } else {
              this.$store.dispatch('layout/enableMapAlive')
              setSessionItem('PRE_SCREEN_ID', 'SU-03')
              this.$router.push({
                name: 'facility-detail',
                params: {
                  id:
                    this.shopList[initIndex].FACILITIES_ID ||
                    this.shopList[initIndex].SHISETU_ID,
                },
              })
            }
          })
        }
        // this.$refs.flickity.on('change', this.changeStampCardShop)
      }
      // var nav = new mapboxgl.NavigationControl()
      // this.map.addControl(nav, 'top-left')

      this.$store.dispatch('layout/endLoading')
      this.searchButtonFlag = false
      setTimeout(() => {
        if (this.showSlide) {
          this.mapSwiper.update()
          if (sessionStorage.getItem('index')) {
            this.mapSwiper.slideTo(sessionStorage.getItem('index'))
          }
        }
        this.map.on('movestart', function () {
          parent.setCenter()
        })
        this.map.on('moveend', function () {
          parent.showSearch()
        })

        this.searchButtonFlag = false
        this.research_flag = false
        this.isReserchGASend = false
        setTimeout(function () {
          parent.searchButtonFlag = false
        }, 600)
      }, 500)
    },
    initSwiper() {
      this.mapSwiper = new SwiperMap('#mapSwiper', {
        loop: true,
        slidesPerView: 1.1,
        spaceBetween: 10,
        centeredSlides: true,
        navigation: false,
        breakpoints: {
          560: {
            spaceBetween: 20,
          },
        },
        on: {
          slideChange: this.changeFacilites,
        },
      })
    },
    changeFacilites(argSwiper) {
      const shopIndex = argSwiper.snapIndex
      if (this.count > 0 && this.shopList && this.shopList.length > 0) {
        if (this.popup) {
          this.popup.remove()
        }
        if (this.marker) {
          this.marker.remove()
        }
        if (shopIndex) {
          var index = isNaN(shopIndex) ? shopIndex.realIndex : shopIndex
          index = isNaN(index) ? 0 : index
          this.selectedIndex = index
        } else {
          var index = this.mapSwiper.realIndex
          index = isNaN(index) ? 0 : index
          this.selectedIndex = index
        }
        var latlng = new mapboxgl.LngLat(
          Number(this.shopList[index].LON),
          Number(this.shopList[index].LAT)
        )
        // change point color
        var preDiv = document.getElementById('markerid' + this.preMarkerId)
        preDiv.style.backgroundImage = 'url(' + redMarker + ')'
        preDiv.style.zIndex = '0'
        this.preMarkerId = index
        var markerDivNow = document.getElementById('markerid' + index)
        markerDivNow.style.backgroundImage = 'url(' + blueMarker + ')'
        markerDivNow.style.zIndex = '1'

        this.map.panTo(latlng)
        var html = this.popupHTML(index)

        this.popup = new mapboxgl.Popup({
          closeOnMove: false,
          offset: 15,
          closeButton: false,
        })
          .setLngLat([
            Number(this.shopList[index].LON),
            Number(this.shopList[index].LAT),
          ])
          .setHTML(html)
          .addTo(this.map)

        this.popup.getElement().addEventListener('click', () => {
          if (!this.$store.state.auth.loggedIn && this.shopList[shopIndex].MENBER_ONLY_FLAG === '1') {
            this.$popup({
              text: '施設の詳細を表示するにはログインを行ってください。',
            })
          } else {
            this.$store.dispatch('layout/enableMapAlive')
            setSessionItem('PRE_SCREEN_ID', 'SU-03')
            this.$router.push({
              name: 'facility-detail',
              params: {
                id:
                  this.shopList[index].FACILITIES_ID ||
                  this.shopList[index].SHISETU_ID,
              },
            })
          }
        })

        setTimeout(function () {
          parent.searchButtonFlag = false
        }, 400)

        if (this.showSlide) {
          setSessionItem('index', this.mapSwiper.realIndex)
        } else {
          setSessionItem('index', shopIndex)
        }
      }
    },
    getShopList() {
      this.isAlertGASend = false
      var shopData = sessionStorage.getItem('MAP_SHOP')
      if (!shopData) {
        sessionStorage.removeItem('index')
        this.selectedIndex = 0
        this.searchShop()
      } else {
        var type = sessionStorage.getItem('TYPE')
        this.shopList = []
        if (type === '1') {
          const data = JSON.parse(shopData)
          this.count = data.COUNT
          shopData = data.fc
          for (var key of Object.keys(shopData)) {
            if (!shopData[key]) {
              continue
            }
            var shops = shopData[key].shop
            for (var j = 0; j < Object.keys(shops).length; j++) {
              if (shops[j].SHISETU_ID) {
                this.shopList.push(shops[j])
              }
            }
          }
        } else {
          shopData = JSON.parse(shopData).shop
          this.shopList = shopData
        }
        if (sessionStorage.getItem('PRE_SCREEN_ID') === 'SU-05') {
          sessionStorage.removeItem('index')
          this.selectedIndex = 0
        }
        if (this.shopList.length == 0) {
          this.center = {
            lat: 35.681167,
            lng: 139.767052,
          }
        }
        this.changeShopList()
        setTimeout(() => {
          if (this.$store.state.env.mapboxAccessToken.length > 0) {
            this.initMap()
          } else {
            setTimeout(this.initMap(), 500)
          }
        }, 200)
      }
    },
    // 施設詳細店舗データ
    searchShop() {
      if (!this.searchingFlag) {
        this.searchingFlag = true
        const params = getFaciliteisSearchParam()
        if (params.SORT !== this.SORT_NAME && params.SORT !== this.SORT_DIST) {
          params.SORT = this.SORT_DIST
          setSessionItem('SORT', this.SORT_DIST)
        }
        if (!params.DIST) {
          params.DIST = 1
        }
        params.session_id = this.$store.state.auth.sessionId
        params.type = '1'
        if (params.LONGITUDE === '0.0' && params.LATITUDE === '0.0') {
          // TODO: 位置情報OFF
          this.$store.dispatch('layout/endLoading')
          if(!this.isAlertGASend)
          {
            this.isAlertGASend = true
            window.dataLayer.push({
              event: 'Webview',
              ap_screen_name: 'JAFナビ_地図表示_位置情報OFF',
            })
          }
          popup({
            text:
              '位置情報の取得に失敗しました。</br>現在地を表示するには、端末の位置情報サービスをオンにしてください。',
          })
          this.initMap()
        } else {

          var formData = new FormData();
          for (var k in params) {
            formData.append(k, params[k] ?? "");
          }

          this.$.post(API_SHOP_LIST_FC, formData)
            .then((response) => {
              var statusCode = response.data.status_code
              if (statusCode === '00') {
                if(this.research_flag)
                {
                  if(!this.isReserchGASend)
                  {
                    this.isReserchGASend = true
                    window.dataLayer.push({
                      event: 'Webview',
                      ap_screen_name: 'このエリアを探す',
                    })
                  }
                }
                sessionStorage.removeItem('index')
                this.selectedIndex = 0
                this.shopList = []
                var shopData = response.data.fc
                for (var i = 0; i < Object.keys(shopData).length; i++) {
                  var shops = shopData[i].shop
                  for (var j = 0; j < Object.keys(shops).length; j++) {
                    if (shops[j].SHISETU_ID && shops[j].WEB_FLAG != 1) {
                      this.shopList.push(shops[j])
                    }
                  }
                }
                this.count = Object.keys(this.shopList).length
                // this.shopList = response.data.shop
                setSessionItem('SHOP', JSON.stringify(response.data))
                setSessionItem('TYPE', '1')
                this.changeShopList()
                this.initMap()
                if (response.data.COUNT >= 150) {
                  this.$store.dispatch('layout/startLoading')
                  if(!this.isAlertGASend)
                  {
                    this.isAlertGASend = true
                    window.dataLayer.push({
                      event: 'Webview',
                      ap_screen_name: 'JAFナビ_地図表示_施設検索_150件以上',
                    })
                  }
                  setTimeout(() => {
                    this.$store.dispatch('layout/endLoading')
                    // excessPopup()
                    this.$popup({
                      // position: '25vh',
                      text:
                        '大変多くの施設が検索されました。<br>ネットワークの関係上、150件以上は表示されません。<br><br>目的の施設が検索結果にない場合は、キーワード、ジャンル、エリアを指定して再検索してください。',
                    })
                  }, 2000)
                }
                setTimeout(function () {
                  parent.searchButtonFlag = false
                }, 300)
              } else {
                this.$store.dispatch('layout/endLoading')
              }
            })
            .catch((e) => {
              this.$store.dispatch('layout/endLoading')
            })
            .finally(() => {
              this.searchingFlag = false
            })
        }
      }
    },
    // 施設詳細店舗データ
    changeShopList() {
      for (var i = 0; i < Object.keys(this.shopList).length; i++) {
        if (this.shopList[i].WB_NAIYO1 !== '') {
          if (this.shopList[i].WB_GAKURITU1 !== '') {
            var gakuritu = '' + this.shopList[i].WB_GAKURITU1
            // 割引額が入っていた場合
            if (this.shopList[i].WB_TANIKU1 === '1') {
              // 割引単位区分が1(％)だった場合
              if (!gakuritu.match('/.*引.*/')) {
                // 割引額に「引」が含まれていない場合
                if (!gakuritu.match('/.*%.*/')) {
                  // 割引額に「％」が含まれていない場合
                  // 割引額に「％割引」を付与
                  this.shopList[i].WB_GAKURITU1 =
                    this.shopList[i].WB_GAKURITU1 + '％割引'
                } else {
                  // 割引額に「％」が含まれていた場合
                  // 割引額に「引き」を付与
                  this.shopList[i].WB_GAKURITU1 =
                    this.shopList[i].WB_GAKURITU1 + '割引'
                }
              }
            } else if (this.shopList[i].WB_TANIKU1 === '2') {
              // 割引単位区分が2(円)だった場合
              if (!gakuritu.match('/.*引.*/')) {
                // 割引額に「引」が含まれていない場合
                if (!gakuritu.match('/.*円.*/')) {
                  // 割引額に「円」が含まれていない場合
                  // 割引額に「円引」を付与
                  this.shopList[i].WB_GAKURITU1 =
                    this.shopList[i].WB_GAKURITU1 + '円引'
                } else {
                  // 割引額に「円」が含まれていた場合
                  // 割引額に「引き」を付与
                  this.shopList[i].WB_GAKURITU1 =
                    this.shopList[i].WB_GAKURITU1 + '引'
                }
              }
            }
          }
        } else {
          this.shopList[i].WB_NAIYO1 =
            this.shopList[i].MEISYO || this.shopList[i].NAME
        }
        if (
          this.shopList[i].PHOTO1 !== '' &&
          this.shopList[i].PHOTO1 !== 'null' &&
          this.shopList[i].PHOTO1 !== null
        ) {
          this.shopList[i].PHOTO1 =
            // this.$store.state.env.href +
            this.$store.getters['env/apiBase'] +
            '/images/ph' +
            ('00000000' + this.shopList[i].PHOTO1).slice(-8) +
            '.jpg'
        } else {
          this.shopList[i].PHOTO1 = ''
        }
        if (
          this.shopList[i].GENRE1 !== '' &&
          this.shopList[i].GENRE1 !== 'null' &&
          this.shopList[i].GENRE1 !== null
        ) {
          genre.map((genreData) => {
            if (this.shopList[i].GENRE1 === genreData.code) {
              this.shopList[i].GENRE1 = genreData.name
            }
          })
        }
        if (
          this.shopList[i].SUB_GENRE1 !== '' &&
          this.shopList[i].SUB_GENRE1 !== 'null' &&
          this.shopList[i].SUB_GENRE1 !== null
        ) {
          genre.map((genreData) => {
            if (this.shopList[i].SUB_GENRE1 === genreData.code) {
              this.shopList[i].SUB_GENRE1 = genreData.name
            }
          })
        }
      }
      this.searchButtonFlag = false
      if (this.count > 0) {
        this.hasResult = true
      } else {
        if(!this.isAlertGASend)
        {
          this.isAlertGASend = true
          window.dataLayer.push({
            event: 'Webview',
            ap_screen_name: 'JAFナビ_地図表示_施設検索_0件',
          })
        }
        this.showMask = true
        this.hasResult = false
      }
      this.$store.dispatch('layout/endLoading')
      this.windowHeightSet()
    },
    cutString(string) {
      var cutFigure = '30' // カットする文字数
      var afterTxt = ' …' // 文字カット後に表示するテキスト
      var textLength = string.length
      var textTrim = string.substr(0, cutFigure)

      var returnString = string

      if (cutFigure < textLength) {
        returnString = textTrim + afterTxt
      }
      return returnString
    },
    clickPoint(position) {
      for (var i = 0; i < Object.keys(this.shopList).length; i++) {
        if (
          position.lat === Number(this.shopList[i].LAT) &&
          position.lng === Number(this.shopList[i].LON) &&
          this.showSlide
        ) {
          this.mapSwiper.slideTo(i)
        } else if (
          position.lat === Number(this.shopList[i].LAT) &&
          position.lng === Number(this.shopList[i].LON) &&
          !this.showSlide
        ) {
          this.changeFacilites(i)
        }
      }
    },
    window_size_set: function () {
      var winW = window.innerWidth
      var winH = 0
      // 2020/03/31 グローバルメニューがみえない修正に従って、高さを調整
      if (winW <= 560) {
        // winH = window.innerHeight - 126 + 64
        winH = window.innerHeight - 56 - 52
        if(this.isLinksMode)
        {
          winH = winH + 58;
        }
        var element = document.getElementById('map_container')
        if (element) {
          element.style.height = winH + 'px'
        }
      } else {
        winH = window.innerHeight - 160 + 150
        var element = document.getElementById('map')
        if (element) {
          element.style.height = winH + 'px'
        }
      }
    },
    saveSession() {
      if (this.showSlide) {
        setSessionItem('index', this.mapSwiper.realIndex)
      } else {
        setSessionItem('index', this.selectedIndex)
      }
      setSessionItem('ZOOM', this.map.getZoom())
    },
    reSearch() {
      window.dataLayer.push({
        event: 'このエリアを探すボタン押下時',
        ap_screen_name: 'このエリアを探すボタン押下時',
      })
      this.$store.dispatch('layout/startLoading')
      var zoomLevel = this.map.getZoom()
      var dist = 50
      var centerLatExp = this.Ketasoroe(this.map.getCenter().lat)
      var centerLngExp = this.Ketasoroe(this.map.getCenter().lng)
      if (zoomLevel >= 14) {
        dist = 1
      } else if (zoomLevel >= 13) {
        dist = 5
      } else if (zoomLevel >= 12) {
        dist = 10
      } else if (zoomLevel >= 11) {
        dist = 20
      }

      if (this.now_pos_flag) {
        setSessionItem('POINT_SEARCH', '')
        this.$store.dispatch('facilitySearch/uncheckPointSearch')
        this.$store.dispatch('facilitySearch/setTempIsPointSearch', false)
        setSessionItem('NOW_AROUND', '1')
        this.$store.dispatch('facilitySearch/setIsNowAround', true)
        this.$store.dispatch('facilitySearch/setTempIsNowAround', true)
      } else {
        setSessionItem('POINT_SEARCH', 1)
        this.$store.dispatch('facilitySearch/setAreaCode', '')
        this.$store.dispatch('facilitySearch/setTempPrefecture', '')
        this.$store.dispatch('facilitySearch/checkPointSearch')
        this.$store.dispatch('facilitySearch/setTempIsPointSearch', true)
        setSessionItem('NOW_AROUND', '')
        this.$store.dispatch('facilitySearch/setIsNowAround', false)
        this.$store.dispatch('facilitySearch/setTempIsNowAround', false)
      }
      setSessionItem('DIST', dist)
      this.center.lat = centerLatExp
      this.center.lng = centerLngExp
      setSessionItem('LAT', centerLatExp)
      setSessionItem('LON', centerLngExp)
      this.$store.dispatch('facilitySearch/setLonLat', {
        lon: centerLngExp,
        lat: centerLatExp,
      })
      setSessionItem('ZOOM', zoomLevel)
      setSessionItem('SORT', this.SORT_DIST)
      sessionStorage.removeItem('COUPON_NO')
      sessionStorage.removeItem('AREA')
      sessionStorage.removeItem('SHOP_AREA')
      sessionStorage.removeItem('SHOP_PREFECTURE')
      if (this.showSlide) {
        this.mapSwiper.slideTo(0)
      }
      sessionStorage.removeItem('index')
      this.selectedIndex = 0
      this.research_flag = true
      this.searchShop()
    },
    Ketasoroe: function (value) {
      var decimalPlaces = 6
      var strValue =
        Math.round(value * Math.pow(10, decimalPlaces)) /
          Math.pow(10, decimalPlaces) +
        ''

      var decimalPoint = strValue.indexOf('.')
      var valueInt = ''
      var valueDec = ''
      if (decimalPoint === -1) {
        valueInt = strValue
        valueDec = ''
      } else {
        valueInt = strValue.substring(0, decimalPoint)
        valueDec = strValue.substring(decimalPoint + 1, strValue.length)
      }
      while (valueDec.length < decimalPlaces) {
        valueDec += '0'
      }
      var valueExp = valueInt + '.' + valueDec
      return valueExp
    },
    showSearch() {
      if (
        this.center.lat !== this.map.getCenter().lat ||
        this.center.lng !== this.map.getCenter().lng
      ) {
        // console.log('show_search')
        this.searchButtonFlag = true
      }
    },
    setCenter: function () {
      this.center.lat = this.map.getCenter().lat
      this.center.lng = this.map.getCenter().lng
      this.now_pos_flag = false
    },
    moveToNowPos: function () {
      this.$store.dispatch('layout/startLoading')
      watchPosition()
        .then((res) => {
          this.$store.dispatch('layout/endLoading')
          var latlng = new mapboxgl.LngLat(
            Number(res.longitude),
            Number(res.latitude)
          )
          this.map.panTo(latlng)
          this.now_pos_flag = true
        })
        .catch(({ result, code }) => {
          console.log(code)
          this.$store.dispatch('layout/endLoading')
          if (code == 1) {
            if(!this.isAlertGASend)
            {
              this.isAlertGASend = true
              window.dataLayer.push({
                event: 'Webview',
                ap_screen_name: 'JAFナビ_地図表示_位置情報OFF',
              })
            }
            this.$popup({
              text:
                '位置情報の取得に失敗しました。</br>現在地を表示するには、端末の位置情報サービスをオンにしてください。',
            })
          } else {
            if(!this.isAlertGASend)
            {
              this.isAlertGASend = true
              window.dataLayer.push({
                event: 'Webview',
                ap_screen_name: 'JAFナビ_地図表示_位置情報取得失敗',
              })
            }
            this.$popup({
              text:
                '位置情報の取得に失敗しました。</br>場所を変えてもう一度お試しください。',
            })
          }
        })
    },
    onMoveSearchDetail() {
      sessionStorage.removeItem('ZOOM')
      sessionStorage.removeItem('SHOP')
      sessionStorage.removeItem('MAP_SHOP')
      this.$store.dispatch(
        'facilitySearch/setDisplayMode',
        DISPLAYMODE.CONDITION
      )
      this.$store.dispatch('layout/enableMapAlive')
      setSessionItem('PRE_SCREEN_ID', 'SU-03')
      this.$router.push({ name: 'facility-search' })
    },
    clearToTop() {
      this.$store.dispatch('facilitySearch/setDisplayMode', DISPLAYMODE.START)
      clearSessionSearch()
      this.$store.dispatch('facilitySearch/clearSearch')
      this.$store.dispatch('layout/disableMapAlive')
      this.$router.push({ name: 'facility-search' })
    },
    onMoveFacilityDetail(shopNo,member_onley_flag) {
      if (shopNo !== '') {
        if (!this.$store.state.auth.loggedIn && member_onley_flag === '1') {
          this.$popup({
            text: '施設の詳細を表示するにはログインを行ってください。',
          })
        } else {
          this.$store.dispatch('layout/enableMapAlive')
          setSessionItem('PRE_SCREEN_ID', 'SU-03')
          this.$router.push({ name: 'facility-detail', params: { id: shopNo } })
        }
      }
    },
    toSearchResult() {
      this.$store.dispatch('layout/disableMapAlive')

      window.dataLayer.push({
        event: '一覧表示ボタン押下時',
        ap_screen_name: 'JAFナビ_施設詳細_地図表示から施設情報表示',
      })

      toSearchResultWithQuery()
    },
    windowHeightSet() {
      var wh = window.innerHeight
      // ここでヘッダー、フッターの高さを設定ください。
      // document.getElementsByClassName('headerWrap')[0].offsetHeight + document.getElementsByClassName('footerWrap')[0].offsetHeight;
      // になるかと思われます。

      if(this.isLinksMode)
      {
        var gWrapHeight = 0
        if (!this.isMobile) {
          gWrapHeight = 3
        }
        var hitHeight = document.getElementsByClassName('top_btn')[0].offsetHeight
        document.getElementById('map_area').style.height =
          wh - gWrapHeight + 'px'
        document.getElementById('map').style.height =
          wh - gWrapHeight - 62 + 'px'
        document.getElementById('jaf_container').style.height = 'auto'
      }
      else {
        var gWrapHeight = 0
        if (!this.isMobile) {
          gWrapHeight = 110
        }
        var hitHeight = document.getElementsByClassName('top_btn')[0].offsetHeight
        document.getElementById('map_area').style.height =
          wh - gWrapHeight - 56 + 'px'
        document.getElementById('map').style.height =
          wh - gWrapHeight - 52 - 56 + 'px'
        document.getElementById('jaf_container').style.height = 'auto'
      }

    },
    popupHTML(index) {
      var html = ''
      var appTagHtml =
        this.shopList[index].COUPON == 1
          ? `<p class="one_tag tag_app"
                              ><span>アプリクーポン</span></p
                            >`
          : ''
      var limitedTagHtml =
        this.shopList[index].TOKUBETU_FLAG == 1
          ? `<p class="one_tag tag_limited"
                              ><span>特別優待</span></p
                            >`
          : ''
      var premiumTagHtml =
        this.shopList[index].PREMIAM_FLAG == 1
          ? `<p class="one_tag tag_premium"
                              ><span>プレミアム優待</span></p
                            >`
          : ''
      var onlineTagHtml =
        this.shopList[index].WEB_FLAG == 1
          ? `<p class="one_tag tag_online"
                              ><span>オンライン優待</span></p
                            >`
          : ''
      if (!this.showSlide) {
        html =
          `<div class="shop_box">
                  <div class="one_box sample"
                    ><!-- 仮位置指定のためsampleクラスを追加しています。 -->
                    <a href="javascript:void(0);" class="map_popup_box">
                      <div class="box_inner">
                        <div class="subject">
                          <p class="title"
                            >${this.shopList[index].WB_NAIYO1}</p
                          >
                        </div>
                        <div class="info">
                          <div class="img">
                            <div class="img-container">
                              <img src="${this.shopList[index].PHOTO1}" onerror="${this.defaultImage}"
                          /></div></div>
                          <div class="data">
                            <p class="tag">${this.shopList[index].GENRE1}:${this.shopList[index].SUB_GENRE1}</p>
                            <p class="shop_name"
                              >${this.shopList[index].MEISYO}</p
                            >
                          </div>
                        </div>
                      </div>
                       <div class="tag_list">` +
          appTagHtml +
          limitedTagHtml +
          onlineTagHtml +
          premiumTagHtml +
          `</div>
                    </a>
                  </div>
                </div>
              </div>`
      } else {
        html =
          '<a style="text-decoration: underline; color: blue;">' +
          this.cutString(this.shopList[index].MEISYO) +
          '</a>'
      }
      return html
    },
    errorImg() {
      console.log('error')
    },
    filterObject(obj, callback) {
      return Object.fromEntries(
        Object.entries(obj).filter(([key, val]) => callback(val, key))
      )
    },
  },
}
</script>

<template>
  <Layout>
    <div id="all_wrapper">
      <div id="app">
        <div id="su06_contents">
          <div id="map_area">
            <div id="map_search">
              <div class="top_btn">
                <div class="content_limit_cover">
                  <div class="hit">
                    <p
                      ><span class="subject">ヒット件数</span
                      ><span class="num">{{ count }}件</span></p
                    >
                  </div>
                  <a class="btn wide" @click="onMoveSearchDetail"
                    ><span class="icon"
                      ><img src="@img/icon_72_glass.png" /></span
                    ><span>条件の変更</span></a
                  >
                  <a class="btn" @click="clearToTop"
                    ><span class="icon"><img src="@img/icon_72_top.png" /></span
                    ><span>検索TOP</span></a
                  >
                </div>
              </div>
            </div>

            <!-- 地図部分 -->
            <div id="map">
              <div id="map_container" class="map_cover content_limit_cover">
                <div v-if="searchButtonFlag" class="area_search">
                  <a class="" @click="reSearch"
                    ><span>このエリアで探す</span></a
                  >
                </div>
                <div class="now_position_button" @click="moveToNowPos">
                  <img src="@img/map/now_position_shadow.png" />
                </div>
                 <div class="now_position_button info_button" @click="showInformation">
                  <img src="@img/map/question.png" />
                </div>
                <div
                  v-if="!hasResult && showMask"
                  class="no_result_msg_box"
                  @click="closeMask"
                >
                  <p>検索条件に該当する優待施設はありません。</p>
                  <p>条件を変更して、再検索してください。</p>
                </div>
                <div v-if="noHit" class="no_hit">
                  <p
                    >検索条件に該当する優待施設はありません。<br />条件を変更して、再検索してください。</p
                  >
                </div>
              </div>
              <div v-if="!showMask" id="slide_area" :class="slideAreaCss">
                <div class="content_limit_cover">
                  <div v-if="hasResult" class="list_link">
                    <a class="button" @click="toSearchResult"
                      ><span class="icon"
                        ><img src="@img/icon_72_list_wh.png" /></span
                      ><span class="text">一覧で見る</span></a
                    >
                  </div>
                  <div v-if="showSlide" id="mapSwiper" class="swiper-container">
                    <div class="swiper-wrapper">
                      <div v-for="shop in shopList" class="swiper-slide">
                        <a
                          href="javascript:void(0);"
                          @click="onMoveFacilityDetail(shop.SHISETU_ID,shop.MENBER_ONLY_FLAG)"
                        >
                          <div class="box_inner">
                            <div class="subject">
                              <p class="title"
                                >{{ shop.WB_NAIYO1 }}{{ shop.WB_GAKURITU1 }}</p
                              >
                            </div>
                            <div class="info">
                              <div class="img">
                                <div class="img-container"
                                  ><img
                                    :src="shop.PHOTO1 ? shop.PHOTO1 : noImg"
                                    :onerror="defaultImage"
                                    loading="lazy"
                                /></div>
                              </div>
                              <div class="data">
                                <p class="tag"
                                  >{{ shop.GENRE1 }}:{{ shop.SUB_GENRE1 }}</p
                                >
                                <p class="shop_name">{{
                                  shop.MEISYO || shop.NAME
                                }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="tag_list map_tag_list">
                            <p v-if="shop.COUPON == 1" class="one_tag tag_app"
                              ><span>アプリクーポン</span></p
                            >
                            <p
                              v-if="shop.TOKUBETU_FLAG == 1"
                              class="one_tag tag_limited"
                              ><span>特別優待</span></p
                            >
                            <p
                              v-if="shop.WEB_FLAG == 1"
                              class="one_tag tag_online"
                              ><span>オンライン優待</span></p
                            >
                            <p
                              v-if="shop.PREMIAM_FLAG == 1"
                              class="one_tag tag_premium"
                              ><span>プレミアム優待</span></p
                            >
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.shop_box .one_box {
  position: absolute;

  /* max-width: 300px; */
  width: 300px;
  /* width: 40%; */
}
.shop_box .one_box.sample {
  /* top: 50%; */
  /* left: 50%; */
  transform: translate(-50%, -90%);
}
.shop_box .one_box a {
  display: block;
  border: 1px solid #d6d6d6;
  border-radius: 5px;
  background-color: #ffffff;
  text-decoration: none;
  overflow: hidden;
}

/* 上に載せる三角アイコン */
.shop_box .one_box a:before {
  content: '';
  position: absolute;
  bottom: -26px;
  left: 50%;
  margin-left: -13px;
  border: 13px solid transparent;
  border-top: 14px solid #ffffff;
  z-index: 2;
}
/* 下に載せる三角アイコン */

.shop_box .one_box .subject {
  background-color: #001a70;
  padding: 7px 20px;
  text-align: left;
}
.shop_box .one_box .subject .title {
  width: 100%;
  color: #ffffff;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.02em;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.shop_box .one_box .info {
  padding: 10px;
  font-size: 0;
}
.shop_box .one_box .info .img {
  display: inline-block;
  vertical-align: top;
  width: 68px;
  margin-right: 13px;
  height: 51px;
}
.shop_box .one_box .info .img .img-container {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.shop_box .one_box .info .img img {
  max-width: 100%;
  max-height: 51px;
}
.shop_box .one_box .info .data {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 81px);
  text-align: left;
}
.shop_box .one_box .info .data .tag {
  color: #0a0044;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.02em;
}
.shop_box .one_box .info .data .shop_name {
  margin-top: 5px;
  color: #333333;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.02em;
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.marker {
  width: 19px;
  height: 26px;
  background-image: url('../../assets/img/map/yahooMarkerIcon.png');
}
.marker2 {
  width: 19px;
  height: 26px;
  z-index: 1;
  /* background-color: blue; */
  background-image: url('../../assets/img/map/yahooMarkerIcon_青.png');
}
.no_result_msg_box {
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 14;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  background: rgba(0, 0, 0, 0.4);
}
.map_popup_box {
  height: 119px;
}
@media screen and (min-width: 768px) {
  .no_result_msg_box {
    font-size: 16px;
  }
  .tag_list .one_tag span {
    padding-top: 0.8px;
  }
}
@media screen and (max-width: 767px) {
  #slide_area.no_result {
    height: 40px !important;
  }
  .shop_box .one_box a:after {
    content: '';
    position: absolute;
    bottom: -27px;
    left: 50%;
    margin-left: -17px;
    border: 14px solid transparent;
    border-top: 14px solid #d6d6d6;
    z-index: 1;
  }
}
</style>
<style lang="scss" src='@assets/css/SU-06.scss' scoped>
